import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { deletedmember } from "../../../services/admin";
import { useNavigate } from "react-router-dom";

export default function DeletedMember() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const columnDefs = [
     {
                headerName: "Actions",
                field: "id",
                width: 160,
                sortable: true,
                resizable: true,
                filter: false,
                floatingFilter: false,
                cellStyle: { textAlign: "left" },
                cellRenderer: function (params) {
                    return (
                        <div className="text-center">
                            <a
                                className="btn-sm btn-success me-2" title="Member Profile"
                                onClick={() => navigate(`/member/memberprofile/${params.value}`)}
                            >
                                <i className="fa fa-user"></i>
                            </a>
                            
                        </div>
                    );
                },
            },
    { headerName: "Member Name", field: "member_name", sortable: true, resizable: true },
    {
      headerName: "DOB", field: "member_dob", sortable: true, resizable: true,
      cellRenderer: (p) => (p.value ? moment(p.value).format("DD-MM-YYYY") : ""),
    },
    { headerName: "Phone", field: "phone_no", sortable: true, resizable: true },
    { headerName: "Group", field: "group_name", sortable: true, resizable: true },
    { headerName: "Branch", field: "branch_name", sortable: true, resizable: true },
    { headerName: "Staff", field: "staff_name", sortable: true, resizable: true },
  ];

  useEffect(() => {
    const temp = new FormData();
    temp.append("branch", localStorage.getItem("branch"));
    deletedmember(temp).then((res) => {
      if (res?.status === true) {
        setRows(res.data || []);
      }
    });
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Deleted Members</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Member</a></li>
          <li className="breadcrumb-item active" aria-current="page">Deleted Members</li>
        </ol>
      </div>
      <div className="content-body">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">Deleted Member List</h2>
              </div>
              <div className="card-body">
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={rows}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
